module.exports = __webpack_public_path__ + "img/logo.829e6343.png";